// components/Composite/ThumbnailGallery/ThumbnailGallery.js
import PropTypes from 'prop-types';
import { Image } from '../../Atoms';

const ThumbnailGallery = ({ images = [], columns = 3, sectionWidth = 'section-full' }) => {
  if (!images || images.length === 0) return null;

  return (
    <section className={`section ${sectionWidth}`}>
      <div className="section__inner">
        <div className="section__body">
          <div className={`grid-${columns} grid-gap-normal`}>
            {images.map((image, index) => (
              <ThumbnailCard key={image.id ?? index} image={image} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

const ThumbnailCard = ({ image }) => {
  const card = (
    <div className="card card-feature">
      <div className="card-feature-background">
        <Image image={image} fit="cover" />
      </div>
    </div>
  );

  return image.href ? (
    <a href={image.href} className="block no-underline">
      {card}
    </a>
  ) : (
    card
  );
};

ThumbnailGallery.propTypes = {
  images: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      src: PropTypes.string,
      full_url: PropTypes.string,
      fullUrl: PropTypes.string,
      url: PropTypes.string,
      alt: PropTypes.string,
      href: PropTypes.string,
    })
  ),
  columns: PropTypes.oneOf([2, 3, 4]),
  sectionWidth: PropTypes.string,
};

export default ThumbnailGallery;